import Rails from "@rails/ujs";

export default ({ transferBookingResourceSkuId, success, error }) => {
  Rails.ajax({
    type: "DELETE",
    dataType: "json",
    url: "/api/external_positions/remove_associations",
    beforeSend: (xhr, options) => {
      xhr.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
      // eslint-disable-next-line no-param-reassign
      options.data = JSON.stringify({
        transfer_booking_resource_sku_id: transferBookingResourceSkuId,
      });
      return true;
    },
    success,
    error,
  });
};
